import type { CSSProperties } from 'react';

export const ASSISTANT_SUCCESS_BUTTON_STYLE = {
  '--button-bg': 'var(--success)',
  '--button-bg-hover': 'var(--success-hover)',
  '--button-bg-pressed': 'var(--success-hover)',
  '--button-fg': 'var(--success-foreground)',
} as CSSProperties;
